/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the unit name/label
 *   * DELTA : the minimum delta parameter
 *   * PERIOD : the forced read period parameter
 *   * SPECIAL_ACQUISITION_COUNT : the number of deviant tags
 */
export enum UnitAcquisitionSortFieldName {
  NAME = 'NAME',
  DELTA = 'DELTA',
  PERIOD = 'PERIOD',
  SPECIAL_ACQUISITION_COUNT = 'SPECIAL_ACQUISITION_COUNT'
}
